<template>
  <v-card
    :loading="loading"
    height="100%"
    flat
    tile
  >
    <v-row
      v-if="loading"
      class="fill-height"
      align-content="center"
      justify="center"
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      >
        <v-icon>mdi-google</v-icon>
      </v-progress-circular>
    </v-row>

    <iframe v-else :src="editUrl" frameborder="0"></iframe>

    <v-hover v-slot="{ hover }">
      <v-btn 
        @click="$router.push(referrer)"
        :loading="loading"
        color="primary"
        absolute
        bottom
        right
        class="mb-6 pa-2"
        min-width="0"
        rounded
      >
        <v-icon>mdi-check-circle-outline</v-icon>
        <v-expand-x-transition>
          <span v-show="hover" class="transition-ease-in-ease-out mx-2">{{$t('finish_editing')}}</span>
        </v-expand-x-transition>
      </v-btn>
    </v-hover>
  </v-card>
</template>

<style scoped>
  iframe {
    width: 100%;
    height: 100%;
  }
</style>

<script>

import { mapActions } from 'vuex'

import ContentActions from '@/store/content/actions/actions-types'
import EntryActions from '@/store/content/entry/actions-types'
import UpdateBrowserTab from '@/utils/updateBrowserTab'

export default {
  name: 'EditGDoc',

  data() {
    return {
      loading: true,
      editUrl: "",
      permissionId: "",
      referrer: null
    }
  },

  created() {
    window.addEventListener('beforeunload', this.handler, {capture: true})
    window.addEventListener('pageshow', () => {
      try {
        const meta = JSON.parse(window.name);
        if (meta) {
          UpdateBrowserTab.update(window, meta.title, meta.icon)
        }
      } catch {
        console.log("pageshow icon error")
      }
    })
  },

  beforeRouteLeave(to, from, next) {
    this.handler()

    next()
  },

  mounted() {
    this.fetchData()
    this.referrer = this.$route.query.from
  },

  methods: {
    ...mapActions('content/entry', [
      EntryActions.GET_ENTRY_DATA,
    ]),

    ...mapActions('content/actions', [
      ContentActions.EDIT_GDOC,
      ContentActions.FINISH_EDIT_GDOC,
    ]),

    fetchData() {
      this.loading = true

      this[EntryActions.GET_ENTRY_DATA](this.$route.params.nodeId)
        .then((nodeData) => {
          this[ContentActions.EDIT_GDOC](this.$route.params.nodeId)
            .then((result) => {

              if (nodeData.extension === 'gcolab' || nodeData.extension === 'gdrawio') {
                window.location.href = result.editUrl

                return
              }

              this.permissionId = result.permissionId
              this.editUrl = result.editUrl

              this.loading = false
            })
        })

    },

    handler(event) {
      event?.stopPropagation()

      this[ContentActions.FINISH_EDIT_GDOC]({nodeId: this.$route.params.nodeId, params: {permission_id: this.permissionId}})
      .then(() => window.close())
    }
  },
}

</script>
